// Scoring for the calculator preliminary indication.
// Rooted in section 40 of the CPA, Sekhoto jurisdictional facts, s 35 Constitution and
// Zealand/Tyulu/Woji case-law framework. Educational only — not legal advice.

export const SCORE_MAX = 20;

export function scoreLead(a = {}) {
  let s = 0;
  // Warrant analysis — no warrant + SAPS + Schedule 1 test likely engages
  if (a.hadWarrant === 'No') s += 3;
  if (a.reasonExplained === 'No') s += 2;
  if (a.noticeOfRights === 'No') s += 2;    // s 35 breach — no SAP 14A given
  if (a.noticeOfRights === 'Yes') s += 1;   // evidence available
  if (a.broughtToCourt48h === 'No') s += 3;

  // Charge outcome
  const outcome = a.chargesOutcome || '';
  if (outcome === 'Withdrawn' || outcome === 'Dismissed') s += 3;
  else if (outcome === 'Acquitted') s += 2;
  else if (outcome === 'Never charged') s += 2;

  // Length of detention
  const nights = a.nightsDetained;
  if (nights === '8+') s += 4;
  else if (nights === '4-7') s += 3;
  else if (nights === '2-3') s += 2;
  else if (nights === '1') s += 1;

  // Injury / assault
  if (a.wasAssaulted === 'Yes') s += 2;

  // Arresting agency (SAPS = Minister of Police liability path)
  if (a.arrestingAgency === 'SAPS') s += 1;

  return Math.min(SCORE_MAX, s);
}

export function indicationFromScore(score) {
  if (score >= 12)
    return { level: 'Strong',      label: 'Strong indication',      description: 'Multiple factors in your responses point to potentially unlawful conduct. Your matter is likely worth investigating.' };
  if (score >= 8)
    return { level: 'Moderate',    label: 'Moderate indication',    description: 'Several indicators are present. An attorney should review the details.' };
  if (score >= 4)
    return { level: 'Preliminary', label: 'Preliminary indication', description: 'Some indicators are present. A short professional review is recommended.' };
  return { level: 'Limited', label: 'Limited indication', description: 'Based on your responses the indicators are limited — every case still turns on its own facts.' };
}

// Professional WhatsApp message — legalese-light, respectful, structured.
export function buildWhatsappSummary(a, indication) {
  const kv = (k, v) => `• ${k}: ${v || '—'}`;
  const lines = [
    'Good day,',
    '',
    'I would like to enquire about a possible civil claim for unlawful arrest and/or detention.',
    'I have completed the online assessment on myarrestclaim.com and would appreciate a review.',
    '',
    `Preliminary indication: ${indication.label} (${a._score}/${SCORE_MAX})`,
    indication.description,
    '',
    'Location of arrest',
    kv('Province', a.province),
    kv('City / town', a.city),
    '',
    'Circumstances of arrest',
    kv('Approximate date', a.arrestDate),
    kv('Arresting agency', a.arrestingAgency),
    kv('Warrant produced', a.hadWarrant),
    kv('Reason for arrest explained', a.reasonExplained),
    kv('Notice of Rights (SAP 14A) received', a.noticeOfRights),
    kv('Alleged offence', a.allegedOffence),
    '',
    'Detention',
    kv('Nights in custody', a.nightsDetained),
    kv('Brought to court within 48 hours', a.broughtToCourt48h),
    kv('Outcome of charges', a.chargesOutcome),
    kv('Injury or assault during arrest/detention', a.wasAssaulted),
  ];
  if (a.description) {
    lines.push('', 'Additional context', a.description);
  }
  lines.push(
    '',
    'Contact details',
    kv('Full name', a.name),
    kv('Phone', a.phone),
    ...(a.email ? [kv('Email', a.email)] : []),
    '',
    'I confirm the above information is accurate to the best of my knowledge and that I would like to be contacted regarding this matter.',
    '',
    'Kind regards,',
    a.name || '',
  );
  return lines.join('\n');
}
